export const path = {
  LOGIN: "/token",
  FORGOTLINK: "/api/v1/User/sendResetPasswordLink",
  VALIDATELINK: "/api/v1/User/validateLink",
  RESETPASSWORD: "/api/v1/User/resetPassWordLink",
  CHANGEPASSWORD: "/api/v1/User/changePassWord",
  GET_ALL_USER: "/api/v1/User/getAllUser",
  GET_WEIGHT: "/api/v1/Order/getWeight",
  GET_VOLUME: "/api/v1/Order/getVolume",
  ORDER_STATUS: "/api/v1/Order/getOrderStatus",
  SERVICE_LEVEL: "/api/v1/Order/getServiceLevelCodes",
  CONTAINER_MODE: "/api/v1/Order/getContainerMode",
  TRANSPORT_MODE: "/api/v1/Order/getTransportMode",
  INCO_TERM: "/api/v1/Order/getIncoTerms",
  GET_CURRENCY: "/api/v1/Order/getCurrency",
  GET_COUNTRY: "/api/v1/Order/getCountry?country=",
  GET_UNLOCO: "/api/v1/Order/getUnlocos",
  GET_DOC_TYPE: "/api/v1/Order/getDocType",
  GET_PART_NUMBER: "/api/v1/Order/getPartNumber",
  POST_SUPPLY_PART: "/api/v1/Order/PostSupplierPart",
  EDIT_POST_ORDER: "/api/v1/Order/postOrder",
  POST_ORDER: "/api/v1/Order/createUpdateOrder",
  DELETE_SUPPLY_PART: "/api/v1/Order/DeleteSupplierPart",
  SPLIT_ORDER: "/api/v1/Order/splitOrder",
  GET_ORDER: "/api/v1/Order/getOrder",
  SEARCH_ORDER: "/api/v1/Order/orderSearch",
  POST_COMMENT: "/api/v1/Order/postComment",
  GET_ORDER_DETAIL: "/api/v1/Order/getOrderDetail",
  CHANGE_ORDER_STATUS: "/api/v1/Order/statusChange",
  // GET_ORGANIZATION_INFO: "/api/v1/Order/getOrganisationinfo",
  GET_ORGANIZATION_INFO: "/api/v1/Orgnisations/getOrganisationinfo",
  // ADD_ORGANIZATION_OR_CONTACT: "/api/v1/Order/getOrgAddOrContacts",
  // ADD_ORGANIZATION_OR_CONTACT: "/api/v1/Orgnisations/getOrgAddOrContacts",
  GET_CONTAINER_TYPE: "/api/v1/Order/getContainerType",
  POST_ORGANIZATION: "/api/v1/Order/postOrgnisation",
  USER_DETAILS: "/api/v1/User/getUser",
  GET_ORG_CONTACTS: "/api/v1/Orgnisations/getOrgAddOrContacts",
  // GET_ORG_INFO: "/api/v1/Order/getOrgInfobasedOnCode",
  GET_ORG_INFO: "/api/v1/Orgnisations/getOrgInfobasedOnCode",

  GET_LOG: "/api/v1/User/logSearch",
  GET_REPORT: "/api/v1/Order/orderReport",
  DOWNLOAD_LOG: "/api/v1/Order/orderListExportToExcelData",
  // GET_BUYER_SUPPIER: "/api/v1/Order/getSupplierBuyer",
  GET_BUYER_SUPPIER: "/api/v1/Orgnisations/getSupplierBuyer",
  EDIT_ORDER: "/api/v1/Order/editOrder",
  PACK_TYPE: "/api/v1/Order/getPackType",
  GET_DIMENSSIONS: "/api/v1/Order/getUnitOfDimension",
  ORDER_FREEZE: "/api/v1/Order/planningChangeFreezed",
  AGENT_CARRIER: "/api/v1/Orgnisations/getOrgInfobasedOnCode?type=",
  GET_CONTAINER_LOCATION: "/api/v1/Tracking/getContainerLocation",
  TRACKING_USING_MBL: "api/v1/Tracking/getLocationBasedOnMbl",
  USER_LOGG_Download: "/api/v1/User/exportToExcelLoggs",

  GET_LOCATION: "/api/v1/Tracking/getCoordinatesBasedOnUnlocos",
  DELETE_ORDER_LINE: "/api/v1/Order/deleteLine",
  DELETE_PLAN_CONTAINER: "/api/v1/Order/deletePlanningContainer",
  DELETE_ORDER_PLAN: "/api/v1/Order/deletePlanning",
  DELETE_ORDER_SPECIFIC_CONTAINERS: "/api/v1/Order/deleteOrderContainer",
  DELETE_DOCUMENTS: "/api/v1/Order/deleteDocument",
  DOWNLOAD_DOCUMENTS: "/api/v1/Order/downloadDocument",
  DOCUMENT_UPLOAD: "/api/v1/Order/uploadDocument",
  VALIDATE_EXCEL: "/api/v1/Order/validateExcelFileData",
  GET_ORDER_BASED_ON_CONTAINER: "/api/v1/Order/getDetailsBasedOnContainer",
  USER_ACCESS: "/api/v1/User/getPermissions",
  USER_ACCESS_NEW: "api/v1/AccountData/permission",
  GET_ROUTES_BASED_ON_MBL: "/api/v1/Tracking/getRoutesBasedOnMbl",
  CREATE_SHIPMENT_CARGOWISE: "/api/v1/CWone/createShipmentConsoleInCwOne",
  DOWNLOAD_ORDER_REPORT: "/api/v1/Order/downloadReport",
  GET_COLUMN_NAME: "/api/v1/Order/getUpdateReportColumnName",
  UPDATE_COLUMN_NAME: "/api/v1/Order/getUpdateReportColumnName",
  GET_NOTIFICATION_DETAIL: "/api/v1/Notifications/getDetail",
  SUBSCRIBE_NOTIFY: "/api/v1/Notifications/subscribe",
  REMOVE_EMAIL_NOTIFY: "/api/v1/Notifications/deleteAdditionalEmails",
  GET_ORDER_FOR_ATTACH: "/api/v1/Order/getOrderForAttach",
  ATTACH_ORDER: "/api/v1/Order/attachOrder",
  GET_ATTACHED_ORDER: "/api/v1/Order/getAttachedOrder",
  DETACH_ORDER: "/api/v1/Order/detachOrder",
  POST_ORGANIZATION_USER: "/api/v1/Orgnisations/postOrgnisation",
  DELETE_RATE_PER_CONTAINER: "/api/v1/Order/deletePlanningContainerRate",
  //Cost
  COST_FREIGHT: "api/v1/LCL_Price/GetRateByOrigin/OriginCode",
  COST_IPI: "api/v1/IPI_Price/GetRateByOrigin/OriginCode",
  //Sell
  SELL_IPI: "api/v1/IPI_Price/ApplyMarkUp",
  SELL_FREIGHT: "api/v1/LCL_Price/ApplyMarkUp",

  GET_FREIGHT_ORIGIN: "api/v1/LCL_Price/GetAllOrigin",
  GET_FCL_ORIGIN: "api/v1/FCLRate/GetFCLOrigin",
  GET_FCL_PORT_DATA: "api/v1/FCLRate/GetPortData?searchString=",
  GET_FREIGHT_DESTINATION:
    "api/v1/QuoteAndBooking/GetAllDestnByOrgn?OriginCode=",
  GET_FCL_DESTINATION:
    "api/v1/FCLRate/GetFCLOriginSpecificDestination?OriginCode=",
  GET_FREIGHT_CAREER: "api/v1/LCL_Price/GetCarrierWRTOrgNdDest",
  GET_IPI_ORIGIN: "api/v1/IPI_Price/GetAllOrigin",
  GET_IPI_DESTINATION:
    "api/v1/IPI_Price/GetOriginSpecificDestination/OriginCode?OriginCode=",
  GET_FREIGHT_RATE: "api/v1/QuoteAndBooking/GetDQuote",
  GET_FCL_QUOTE: "api/v1/FCLRate/GetFCLQuote",
  GET_IPI_RATE: "api/v1/IPI_Price/GetRatesFromTo",
  CREATE_QUOTE: "api/v1/QuoteAndBooking/CreateQuote",
  CREATE_FCL_QUOTE: "api/v1/FCLRate/CreateFCLQuote",
  BOOK_QUOTE: "api/v1/QuoteAndBooking/BookDQuote",
  BOOK_FCL_QUOTE: "api/v1/FCLRate/BookDFCLQuote",

  CONFIRM_BOOKING_ADMIN: "api/v1/QuoteAndBooking/ConfirmBooking",
  CONFIRM_FCL_BOOKING_ADMIN: "api/v1/FCLRate/ConfirmFCLBooking",

  GET_QUOTE_LIST: "api/v1/QuoteAndBooking/GetQuotesByUserId?UserId=",
  GET_FCL_QUOTE_LIST: "api/v1/FCLRate/GetFCLQuotesByUserId?UserId=",
  GET_USER_ROLE: "api/v1/QuoteAndBooking/GetUserRole",
  GET_CUST_BY_SALE_AGENT: "api/v1/QuoteAndBooking/GetCustBySaleAgent",
  GET_LMD_RATE: "api/v1/QuoteAndBooking/LMDRates",
  GUEST_ACCESS_REQUEST: "api/v1/QuoteAndBooking/GuestAccessRequest",

  SHIPMENT_COLOUM: "api/v2/ShipmentData/shipmentcolumn?emailid=",
  SHIPMENT_DATA: "api/v2/ShipmentData/reportdata?emailid=",
  DOWNLOAD_SHIPMENT_REPORT :"/api/v2/ShipmentData/downloadshipmentreport?emailid=",
  SHIPMENT_COLOUM_CO2: "api/v2/carbonemission/Carboncolumn",
  SHIPMENT_DATA_CO2: "api/v2/carbonemission/carbonreportdata",
  DOWNLOAD_SHIPMENT_REPORT_CO2 :"/api/v2/carbonemission/downloadcarbonreport",
  
  CREATENEW:"api/v1/AccountData/createuser",
  GETPERMISSION:"api/v1/AccountData/permission",
  CREATEPERMISSION:"api/v1/AccountData/permission",
  UPDATEPERMISSION:"api/v1/AccountData/permission"

};
